import { render, staticRenderFns } from "./RazaoHierarquicoReport.vue?vue&type=template&id=65c1d847&scoped=true"
import script from "./RazaoHierarquicoReport.vue?vue&type=script&lang=js"
export * from "./RazaoHierarquicoReport.vue?vue&type=script&lang=js"
import style0 from "./RazaoHierarquicoReport.vue?vue&type=style&index=0&id=65c1d847&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c1d847",
  null
  
)

export default component.exports